module.exports = __webpack_public_path__ + "media/images/responsive/logo/service/logo_hapista-f8d9a6ff93bdd6fe81b37cce26cebbc4.svg";